import React from 'react';
import { FinancialDecisionSuggestion } from '../types';
import '../styles/FinancialDecisionCard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChartLine, faBullseye, faExclamationTriangle, faGem, faLightbulb } from '@fortawesome/free-solid-svg-icons';

interface DecisionCardProps {
  decision: FinancialDecisionSuggestion;
  index: number;
}

const getDecisionIcon = (title: string) => {
  const lowerTitle = title.toLowerCase();
  if (lowerTitle.includes('reduz')) return <FontAwesomeIcon icon={faChartLine} />; // chart down
  if (lowerTitle.includes('aumenta')) return <FontAwesomeIcon icon={faChartLine} />;
  if (lowerTitle.includes('diversif')) return <FontAwesomeIcon icon={faBullseye} />; // target
  if (lowerTitle.includes('emergência') || lowerTitle.includes('reserva')) return <FontAwesomeIcon icon={faLightbulb} />;
  if (lowerTitle.includes('investimento')) return <FontAwesomeIcon icon={faGem} />;
  if (lowerTitle.includes('débita') || lowerTitle.includes('dívida')) return <FontAwesomeIcon icon={faExclamationTriangle} />;
  if (lowerTitle.includes('lucro')) return <FontAwesomeIcon icon={faGem} />;
  if (lowerTitle.includes('custo')) return <FontAwesomeIcon icon={faChartLine} />;
  return <FontAwesomeIcon icon={faLightbulb} />;
};

const getPriorityLevel = (description: string): 'critical' | 'high' | 'medium' | 'low' => {
  const lowerDesc = description.toLowerCase();
  if (lowerDesc.includes('urgente') || lowerDesc.includes('crítico')) return 'critical';
  if (lowerDesc.includes('importante') || lowerDesc.includes('recomenda-se')) return 'high';
  if (lowerDesc.includes('considerarr') || lowerDesc.includes('avaliar')) return 'medium';
  return 'low';
};

const FinancialDecisionCard: React.FC<DecisionCardProps> = ({ decision, index }) => {
  const icon = getDecisionIcon(decision.title);
  const priority = getPriorityLevel(decision.description);

  return (
    <div className={`decision-card priority-${priority}`}>
      <div className="decision-header">
        <div className="decision-title-wrapper">
          <span className="decision-icon">{icon}</span>
          <div>
            <h3 className="decision-title">{decision.title}</h3>
            <span className={`priority-badge priority-${priority}`}>
              {priority === 'critical' && <><span className="dot critical"/> Crítico</>}
              {priority === 'high' && <><span className="dot high"/> Alta Prioridade</>}
              {priority === 'medium' && <><span className="dot medium"/> Médio</>}
              {priority === 'low' && <><span className="dot low"/> Baixa Prioridade</>}
            </span>
          </div>
        </div>
        <span className="decision-number">#{index + 1}</span>
      </div>

      <p className="decision-description">{decision.description}</p>

      {decision.actionItems && decision.actionItems.length > 0 && (
        <div className="decision-actions">
          <h4>Próximos Passos:</h4>
          <ul>
            {decision.actionItems.map((item, idx) => (
              <li key={idx}>{item}</li>
            ))}
          </ul>
        </div>
      )}

      {decision.impact && (
        <div className="decision-impact">
          <div className="impact-item">
            <span className="impact-label">Impacto Estimado:</span>
            <span className={`impact-value ${decision.impact.includes('positivo') ? 'positive' : 'negative'}`}>
              {decision.impact}
            </span>
          </div>
        </div>
      )}

      <div className="decision-footer">
        <small className="disclaimer"><FontAwesomeIcon icon={faLightbulb} /> Sugestão gerada por IA - Use como referência</small>
      </div>
    </div>
  );
};

export default FinancialDecisionCard;
